import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FC } from 'react';
import { DndListItem } from './dnd-list-item';

interface DndModListProps {
  listIds: string[];
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  onRemove: (id: string) => void;
}

export const DndModList: FC<DndModListProps> = ({ listIds, moveItem, onRemove }) => {
  const handleRemove = (removeId: string) => () => {
    onRemove(removeId);
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Потяни меня</TableCell>
            <TableCell>Имя</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listIds.map((modId, index) => (
            <DndListItem key={modId} index={index} modId={modId} moveItem={moveItem} onRemove={handleRemove(modId)} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
